<template>
  <v-dialog v-model="visible" max-width="360" @keydown.esc="reject()" @keydown.enter="accept()">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <v-card>
      <v-card-title class="headline">
        <v-spacer></v-spacer>
        {{ caption }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <div>
          <p>
            {{ $t("Common.title") }} platform is a set of microservices that solve simple common problems on board or word games. The platform was named after
            Nicomachus of Gerasa, an important ancient mathematician and music theorist, best known for his works Introduction to Arithmetic and Manual of
            Harmonics in Greek.
          </p>

          <p>
            The platform is offered to you as is and for free by
            <a href="https://www.assistedcoding.eu">assistedcoding.eu</a>
          </p>

          <p>
            Since it is available for free use, it has not been extensively debugged. By reporting bugs, you can contribute to this service and with your help
            the results will be more accurate.
          </p>
          <p>
            You can report bugs at the
            <a href="https://www.assistedcoding.eu/contact">contact</a> page of the official site
          </p>
          <p>Thank you for using {{ $t("Common.title") }} !</p>
          <p>Have fun !</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" :color="acceptColor" @click="accept()">{{ acceptPrompt }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    acceptColor: {
      type: String,
      required: false,
      default: "success"
    },
    rejectColor: {
      type: String,
      required: false,
      default: "red darken-1"
    },
    acceptPrompt: {
      type: String,
      required: false,
      default: "OK"
    },
    rejectPrompt: {
      type: String,
      required: false,
      default: "No"
    }
  },
  data() {
    return {
      visible: false,
      value: "",
      caption: "About",
      text: "",
      promise: null,
      promiseResolve: null,
      promiseReject: null
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.promise = new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;
      });
      return this.promise;
    },
    accept() {
      this.visible = false;
      this.promiseResolve(this.value);
    },
    reject() {
      this.visible = false;
      this.promiseReject(this.value);
    }
  }
};
</script>
